import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {TreeUtilities, NodeOperations, TreeDOMHelper, TreeNodeHelper} from './TreeHelper';
import {
    Row,
    Col,
    Button,
    FormControl,
    InputGroup,
    Glyphicon,
    Image,
    Carousel,
    CarouselItem,
    Grid,
    Label
} from 'react-bootstrap';

import BUtils from './../../../utilities/BaseUtilities';
import stylesSCTree from './../SCTree.module.css';
import FontAwesome from "react-fontawesome";

export class TreeItemSearch extends PureComponent {
    constructor(props) {
        super(props);

        this.paginateLength = 10;

        this.state = {
            paginate: this.paginateLength
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.items.length > 0 && prevProps.items !== this.props.items) {
            this._retrieveItemList(this.props.items, () => {

            });
        }
    }

    _retrieveItemList(itemList, callback) {
        /*const isContainer = TreeNodeHelper.isSubContainerItem(itemList[0].code);

        if (isContainer) {
            Dict.call('/tree/getItemByKey/' + this.props.projectName + '/' + NodeOperations.retrieveParentKey(itemList[0]) + '/').then((parent) => {
                this.setState({itemList, parent}, callback);
            });
        } else*/
        this.setState({itemList}, callback);
    }

    _buildItemList(printTitle) {
        return this._buildItem(this.state.itemList, printTitle);
    }

    _buildItem(itemArray, printTitle) {
        var Cols = '';
        var pathSrc = '';

        return itemArray.map((item) => {
            pathSrc = '';
            const basicItems = basicContainer.basicItems;

            Cols = basicItems.map((basicItem, index) => {
                var data = item.data[index];
                var type = data.type;
                var isResource = type === 'pathbrowser' || type === 'dropzone' || type === 'pdf-page-number';
                var undefinedFound = /*typeof basicItem.showInSearchResult === 'undefined' ||*/ typeof data === 'undefined';


                if (typeof data !== 'undefined' /*&& basicItem.showInSearchResult === true*/ && isResource) {
                    if (type === 'pathbrowser') {
                        pathSrc = 'http://' + BUtils.getServerUrl() + '/admin/getLocalImage/' + Dict.encodeUrl(JSON.stringify(data.value.path));
                    } else if ((type === 'dropzone' || type === 'pdf-page-number') && data.value.length > 0) {
                        pathSrc = TreeUtilities.buildMultimediaSrc(this.props.projectName, data.value[0], data);
                    }
                }

                return '';

            });

            return <Row className={stylesSCTree['tree-item-search__item']} onClick={() => {
                const containerItem = TreeNodeHelper.getContainerBySubitem(item.code);
                if (true || typeof containerItem === 'undefined') {
                    this.props.callbackOpenItem(item);
                } else {
                    NodeOperations.getItemById(this.props.projectName, NodeOperations.retrieveParentKey(item)).then((parent) => {
                        this.props.callbackOpenItem(item, parent);
                    });
                }
            }}>
                <Col lg={8} md={8}>
                    <Row
                        className={stylesSCTree['tree-item-search__item-title']}>{printTitle ? item.title : ''}{/* - <span>{item.code}</span>*/}</Row>
                    {Cols}
                </Col>
                <Col lg={4} md={4}>
                    {pathSrc.length > 0 ? <img className={stylesSCTree['tree-item-search__item-img']} src={pathSrc}
                                               alt={Dict.t('IMG_NOT_FOUND')}/> : <i>{Dict.t(item.code)}</i>}
                </Col>
            </Row>
        });

    }

    render() {

        var itemList = [];
        var parentItem = '';
        var title = '';
        if (typeof this.state.itemList !== 'undefined' && Object.keys(this.state.itemList).length > 0) {
            //const isSub = TreeNodeHelper.isSubContainerItem(this.state.itemList[0].code)
            itemList = this._buildItemList(isSub);
            title = this.state.itemList[0].title;
            /*if (isSub) {
                parentItem = this._buildItem([this.state.parent], true);
            }*/
            //const parent = NodeOperations.retrieveParentItem()
        }

        return <div id="tree-item-search-page"
                    className={BUtils.joinClasses(stylesSCTree['selected-tree-filter-items-page'], stylesSCTree['selected-tree-filter-items-page--' + (this.props.searchOpen ? 'active' : 'inactive')])}>
            <Grid className={stylesSCTree['tree-item-search']} fluid>
                <Row className={stylesSCTree['tree-item-search__header']}>
                    <h3 className={stylesSCTree['tree-item-search__label-h']}>
                        <Label className={stylesSCTree['tree-item-search__label']}>
                            {title}
                        </Label>
                    </h3>
                </Row>
                <Row className={stylesSCTree['tree-item-search__contents']}>
                    {parentItem}
                    {itemList}
                </Row>
                <Row className={stylesSCTree['tree-item-search__footer']}>
                    <Button className={stylesSCTree['tree-item-search__close-button']} onClick={() => {
                        this.setState({paginate: this.paginateLength, itemList: []});
                        this.props.callbackCloseSearch();
                    }}><FontAwesome name={'times'}/></Button>
                </Row>
            </Grid>
        </div>;
    }

}